import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Rocket, Bell } from 'lucide-react';
import Button from '../components/ui/Button';
import styles from './ComingSoon.module.css';

const ComingSoon = ({ title = 'Coming Soon', description, icon: Icon = Rocket }) => {
    const navigate = useNavigate();

    return (
        <div className={styles.page}>
            <div className={styles.card}>
                {/* Animated glow blob */}
                <div className={styles.glow} />

                <div className={styles.iconWrap}>
                    <Icon size={28} />
                </div>

                <div className={styles.badge}>In Development</div>

                <h1 className={styles.title}>{title}</h1>
                <p className={styles.desc}>
                    {description || `We're working hard on this feature. It'll be ready soon — hang tight!`}
                </p>
                <p className={styles.hint}>Current workflows remain unchanged while this module is being built.</p>

                <div className={styles.actions}>
                    <Button variant="secondary" size="sm" icon={<ArrowLeft size={15} />} className={styles.backBtn} onClick={() => navigate(-1)}>
                        Go back
                    </Button>
                    <Button variant="primary" size="sm" icon={<Bell size={14} />} className={styles.notifyBtn}>
                        Notify me
                    </Button>
                </div>

                {/* Decorative dots */}
                <div className={styles.dots}>
                    <span className={`${styles.dot} ${styles.dot1}`} />
                    <span className={`${styles.dot} ${styles.dot2}`} />
                    <span className={`${styles.dot} ${styles.dot3}`} />
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
